import { useEffect, useState } from 'react';
import styled from 'styled-components';

import SimpleHeader from '../../components/layout/SimpleHeader';
import Footer from '../../components/layout/Footer';
import ClassSearch2 from '../../components/class/class/Search2';
import ClassTable2 from '../../components/class/class/Table2';
import ClassTopButtons2 from '../../components/class/class/TopButtons2';
import ClassTab2 from '../../components/class/class/Tab2';
import { useLocation } from 'react-router-dom';
import QueryString from 'qs';
import { useTranslation } from 'react-i18next';
import useUtil from '../../hooks/useUtil';
import Split from 'react-split';
import TabItem from '../../components/class/class/TabItem';

const Block = styled.div`
  .close-left {
    transform: translate(-33%);
  }


  .table-inside {
    width: 100%;

    th {
      background: ghostwhite;
    }
  }

  .table-basic th,
  td {
    vertical-align: middle;
  }

  h5 {
    margin-left: 5px;
    margin-bottom: 0;
  }

  .arrow {
    font-size: 26px;
    line-height: 26px;
  }

  .date {
    display: inline-block;
    width: 130px;
  }

  .rbc-event {
    text-align: center;
  }
`;

const ClassClass2 = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isCampusDeactived } = useUtil();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const [isExtended, setIsExtended] = useState(false);
  const [tab, setTab] = useState('info');
  const [refreshTable, setRefreshTable] = useState(false);
  const [campusDeactived, setCampusDeactived] = useState(false);

  useEffect(() => {
    if (query.tab) {
      setTab(String(query.tab));
    }
  }, [location]);

  useEffect(() => {
    setCampusDeactived(isCampusDeactived());
  }, [isCampusDeactived]);

  const tabs = [
    {
      menu: 'info',
      menus: 'info,createClass,updateClass',
      text: t('student.student.tab1'),
    },
    {
      menu: 'register',
      menus: 'register,allocateStudent,allocateResult,attendance,refund,retire,retireResult,transfer,transferCalculation',
      text: t('class.class.tab1'),
    },
    {
      menu: 'schedule',
      menus: 'schedule,calendarDetail,rollbook,inputScore',
      text: t('class.class.tab2'),
    },
    {
      menu: 'score',
      menus: 'score',
      text: t('class.class.tab3'),
    },
    {
      menu: 'point',
      menus: 'point',
      text: t('class.class.tab5'),
    },
    {
      menu: 'notice',
      menus: 'notice',
      text: t('class.class.tab4'),
    },
    {
      menu: 'test',
      menus: 'test,testScore',
      text: 'TEST',
    },
    {
      menu: 'article',
      menus: 'article',
      text: 'Articles',
    },
    {
      menu: 'award',
      menus: 'award',
      text: 'Canb Award',
    },
    {
      menu: 'eLearning',
      menus: 'eLearning',
      text: '이러닝 수행율',
    },
    {
      menu: 'report',
      menus: 'report',
      text: 'Report',
    },
    {
      menu: 'daily',
      menus: 'daily',
      text: 'Daily Mission',
    },
  ];

  return (
    <>
    <ClassSearch2
      tab={tab}
    />
    <Block className="content">
      <SimpleHeader
        parentMenu={t('common.menu.class')}
        currentMenu={t('class.class.title1')}
        onlyTitle={true}
      />
      
      <div>
        <Split
          className="splite-divide"
          sizes={[30, 70]}
          minSize={100}
          expandToMin={false}
          gutterSize={10}
          gutterAlign="center"
          snapOffset={30}
          dragInterval={1}
          direction="horizontal"
          cursor="col-resize"
        >
          <div className="col-frame left_panel">
            <ClassTable2
              refreshTable={refreshTable}
            />
          </div>
          <div className="col-frame right_panel">
            <div className='position-relative'>
              <ClassTopButtons2
                isExtended={isExtended}
                setIsExtended={setIsExtended}
                setTab={setTab}
                campusDeactived={campusDeactived}
                classCode={String(query?.classCode)}
                semesterCode={String(query?.semester)}
              />
              <div className="comm-tab__line">
                <ul>
                  {tabs.map(tabItem => (
                    <TabItem
                      tab={tab}
                      setTab={setTab}
                      menu={tabItem.menu}
                      menus={tabItem.menus}
                      text={tabItem.text}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <ClassTab2
              tab={tab}
              setTab={setTab}
              setIsExtended={setIsExtended}
              setRefreshTable={setRefreshTable}
            />
          </div>
        </Split>
      </div>
      <Footer />
    </Block>
    </>
  );
};

export default ClassClass2;
